import { render, staticRenderFns } from "./TeamViewSidebar.vue?vue&type=template&id=80487108&scoped=true&"
import script from "./TeamViewSidebar.vue?vue&type=script&lang=js&"
export * from "./TeamViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TeamViewSidebar.vue?vue&type=style&index=0&id=80487108&lang=scss&scoped=true&"
import style1 from "./TeamViewSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80487108",
  null
  
)

export default component.exports